import React, { useState, useEffect } from "react";
import dropdown from "../assests/images/dropdown.svg";
// import { ForkRight } from "@mui/icons-material";
import axios from "../api/axios";
import LoadingGif from "../assests/images/loading.gif";
export default function Dropdown() {
  // Example data to simulate fetching from a database
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // State to hold the selected value (default to the first item)
  const [selectedValue, setSelectedValue] = useState(null);

  const fetchItems = async () => {
    axios
      .get("/api/get-valid-tokens")
      .then((res) => {
        setItems(res.data.tokensData);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch tokens.");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchItems();
  }, []);
  return (
    <>
      {loading || error ? (
        <div className="text-center" style={{ height: "98px" }}>
          {loading ? (
            <img src={LoadingGif} alt="loading..." height="100%" />
          ) : (
            error && <span className="error-text small-text">{error}</span>
          )}
        </div>
      ) : (
        <>
          <div>
            <button
              className="btn w-100 d-flex justify-content-between align-items-center"
              id="dropdownMenuButton"
              data-bs-toggle={items.length > 0 ? "dropdown" : ""}
              style={{
                maxWidth: "-webkit-fill-available",
                border: "1px solid #e0e0e0",
                paddingRight:"0",
              }}
              disabled={!(items.length > 0)}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  flex: 1,
                  textAlign: "left",
                }}
              >
                {items.length > 0
                  ? selectedValue
                    ? selectedValue.token
                    : "Select Token"
                  : "No Token Found"}
              </span>
              <img src={dropdown} alt="Dropdown" />
            </button>
            {items.length > 0 && (
              <ul
                className="dropdown-menu dropdown-menu-end p-2"
                aria-labelledby="dropdownMenuButton"
                style={{ width: "calc( 100% - 40px)", minWidth: "fit-content" }}
              >
                {items.map((item, index) => (
                  <li key={index}>
                    <button
                      className="dropdown-item pt-2 pb-2 br-2"
                      onClick={() => setSelectedValue(item)}
                      style={{ borderRadius: "8px" }}
                    >
                      {item.token}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="d-flex justify-content-between mt-3">
            <div>
              <span className="review-text small-text">
                {selectedValue?.type &&
                (selectedValue.type === "seat" ||
                  selectedValue.type === "hires-seat")
                  ? "Sample Count"
                  : "Samples Remaining"}
              </span>
              <br />
              <span>
                {selectedValue
                  ? selectedValue.type === "seat" ||
                    selectedValue.type === "hires-seat"
                    ? selectedValue.sampleTotal
                    : selectedValue.sampleremain
                  : "N/A"}
              </span>
            </div>
            <div>
              <span className="review-text small-text ">Exp. Date</span>
              <br />
              <span>
                {selectedValue ? formatDate(selectedValue.expire) : "XX/XX/XX"}
              </span>
            </div>
          </div>
        </>
      )}
    </>
  );
}
const formatDate = (dateString) => {
  const dateObj = new Date(dateString);
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${month}/${day}/${year}`;
};
